import React from "react";
import { Routes, Route, Navigate, NavLink } from "react-router";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { DashboardProvider } from "./context/DashboardContext";
import { ThemeProvider } from "./context/ThemeContext";
import Topbar from "./components/Topbar";
import Loading from "./components/Loading";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Insights from "./pages/Insights";
import Explorer from "./pages/Explorer";
import Admin from "./pages/Admin";

import Advisor from "./pages/Advisor";

function TabNav() {
  const tabs = [
    { to: "/", label: "Overview" },
    { to: "/insights", label: "Insights" },
    { to: "/explorer", label: "Explorer" },
    { to: "/advisor", label: "Advisor" },
  ];

  const { user } = useAuth();
  if (user?.role === "admin") {
    tabs.push({ to: "/admin", label: "Admin" });
  }

  return (
    <div className="flex gap-0 px-6 bg-[#1a1d27] border-b border-[#2a2d3e] overflow-x-auto">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.to === "/"}
          className={({ isActive }) =>
            `px-5 py-3 text-sm font-medium border-b-2 transition-all whitespace-nowrap ${
              isActive
                ? "text-blue-400 border-blue-400"
                : "text-gray-400 border-transparent hover:text-white"
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}

function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) return <Loading message="Loading..." />;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <DashboardProvider>
      <Topbar />
      <TabNav />
      <div className="p-6 max-w-[1400px] mx-auto">
        <Routes>
          <Route index element={<Overview />} />
          <Route path="insights" element={<Insights />} />
          <Route path="explorer" element={<Explorer />} />
          <Route path="advisor" element={<Advisor />} />
          <Route path="admin" element={<Admin />} />
        </Routes>
      </div>
    </DashboardProvider>
  );
}

export default function App() {
  return (
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginGuard />} />
          <Route path="/*" element={<ProtectedLayout />} />
        </Routes>
      </AuthProvider>
  );
}

function LoginGuard() {
  const { user, loading } = useAuth();
  if (loading) return <Loading message="Loading..." />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}
